<template>
  <div>
    <v-container fluid>
      <base-material-card
        icon="mdi-clipboard-text"
        title="รับรายงานตัว ย้ายพนักงรานราชการ กรณีปกติ"
        class="px-5 py-3"
      >
        <v-card class="pa-2" color="white" elevation="2">
          <v-data-table
            :headers="showHeaders"
            :items="conditons_transfer_successs"
            :search="search"
            :loading="loading"
            :item-class="row_classes"
            disable-pagination
            class="white"
          >
            <template v-slot:item.cts_report="{ item }">
              <div v-if="item.cts_college_cc === 'CC'">
                <v-chip color="orange lighten-2" text-color="white">
                  <v-icon left>mdi-information</v-icon>
                  อยู่ระหว่างการขอยกเลิก
                </v-chip>
              </div>
              <div v-else>
                <div v-if="item.cts_report === 'nb'">
                  <v-btn
                    @click="cancelTeach(item.id_cts)"
                    rounded
                    color="orange darken-1"
                    class="white--text"
                  >
                    <v-icon left>mdi-close</v-icon> ขอยกเลิกรายการ
                  </v-btn>
                </div>
                <div v-else-if="item.cts_report === 'dnb'">
                  <v-btn
                    @click="cancelTeach(item.id_cts)"
                    rounded
                    color="orange darken-1"
                    class="white--text"
                  >
                    <v-icon left>mdi-close</v-icon> ขอยกเลิกรายการ
                  </v-btn>
                </div>
                <div v-else>
                  <v-btn
                    @click="receiptTeach(item.id_cts)"
                    rounded
                    color="blue darken-2"
                    class="white--text"
                  >
                    <v-icon left>mdi-account-star</v-icon> รับรายงานตัว
                  </v-btn>
                </div>
              </div>
            </template>

            <template v-slot:item.ex_contract="{item}">
              <v-btn 
                color="blue lighten-1" 
                :href="'#/college/govem_contract_2/?pid=' + item.ctsid_card" 
                target="_blank"
                class="white--text"
              > 
                <v-icon left>mdi-printer</v-icon> พิมพ์ ฟอร์มสัญญาจ้างเพิ่มเติม
              </v-btn>
            </template>

            <template v-slot:item.cts_datetime="{ item }">
              <div v-if="item.cts_college_cc === 'CC'">
                <v-chip color="orange lighten-2" text-color="white">
                  <v-icon left>mdi-information</v-icon>
                  อยู่ระหว่างการขอยกเลิก
                </v-chip>
              </div>
              <div v-else>
                <v-chip color="blue darken-2" class="white--text" v-if="item.cts_report === 'nb'">
                  {{ item.cts_datetime | moment("add", "543 years") | moment("D MMMM YYYY") }}
                </v-chip>
                <v-chip color="orange lighten-2" class="white--text" v-else-if="item.cts_report === 'dnb'">
                  ไม่มารายงานตัว
                </v-chip>
                <v-chip color="grey lighten-1" class="white--text" v-else>
                  ไม่ได้ดำเนินการ
                </v-chip>
              </div>
            </template>

            <template v-slot:item.cts_files="{ item }">
              <div v-if="item.cts_college_cc === 'CC'">
                <v-chip color="orange lighten-2" text-color="white">
                  <v-icon left>mdi-information</v-icon>
                  อยู่ระหว่างการขอยกเลิก
                </v-chip>
              </div>
              <div v-else>
                <div v-if="item.cts_report === 'nb'">
                  <v-btn
                    text
                    rounded
                    color="green darken-1"
                    :href="'/HRvecfiles/' + item.cts_files"
                    target="_blank"
                  >
                    <v-icon>mdi-printer</v-icon>
                  </v-btn>
                </div>
                <div v-else-if="item.cts_report === 'dnb'">
                  <span class="grey--text">ไม่มารายงานตัว</span>
                </div>
                <div v-else>
                  <span class="grey--text">ไม่ได้ดำเนินการ</span>
                </div>
              </div>
            </template>

            <v-alert
              slot="no-results"
              :value="true"
              color="orange lighten-3"
              icon="mdi-alert"
              class="white--text"
            >
              ไม่พบผลลัพธ์ "{{ search }}" ที่คุณกำลังค้นหา.
            </v-alert>
          </v-data-table>
        </v-card>
      </base-material-card>

      <!-- Dialog รับรายงานตัว -->
      <v-layout row justify-center>
        <v-dialog v-model="reportMoveTeachDialog" persistent max-width="80%">
          <v-card class="mx-auto pa-6" color="white" elevation="8">
            <base-material-card
              color="blue darken-2"
              icon="mdi-clipboard-text"
              title="รับรายงานตัว ย้ายพนักงรานราชการ กรณีปกติ"
              class="px-5 py-3 text_google white--text"
            ></base-material-card>
            
            <v-card-text>
              <v-form ref="updatemvtform" lazy-validation>
                <v-row no-gutters>
                  <!-- ข้อมูลพื้นฐาน -->
                  <v-col cols="12" sm="12" md="12">
                    <h3 class="text-center blue--text text--darken-2 mb-4">
                      {{ conditons_transfer_successs_teach.ctsid_card }} :
                      {{ conditons_transfer_successs_teach.full_name }}
                    </h3>
                  </v-col>

                  <!-- สถานะการรายงานตัว -->
                  <v-col cols="12" md="6" class="text-center">
                    <v-radio-group
                      v-model="conditons_transfer_successs_teach.cts_report"
                      row
                      required
                      :rules="[v => !!v || 'กรุณาเลือกสถานะการรายงานตัว']"
                    >
                      <v-radio value="nb">
                        <template v-slot:label>
                          <div>
                            <strong class="blue--text text--darken-2">มารายงานตัว</strong>
                          </div>
                        </template>
                      </v-radio>
                      <v-radio value="dnb">
                        <template v-slot:label>
                          <div>
                            <strong class="orange--text text--darken-2">ไม่มารายงานตัว</strong>
                          </div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-col>

                  <!-- วันที่รายงานตัว -->
                  <v-col cols="12" md="6">
                    <v-menu
                      v-if="conditons_transfer_successs_teach.cts_report === 'nb'"
                      ref="menu2"
                      v-model="menu2"
                      :close-on-content-click="false"
                      :return-value.sync="conditons_transfer_successs_teach.cts_datetime"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="conditons_transfer_successs_teach.cts_datetime"
                          label="วันที่มารายงานตัว"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          locale="th"
                          outlined
                          required
                          :rules="[v => !!v || 'กรุณาเลือกวันที่']"
                          color="blue darken-2"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="conditons_transfer_successs_teach.cts_datetime"
                        no-title
                        scrollable
                        locale="th"
                        color="blue darken-2"
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="grey" @click="menu2 = false">
                          ยกเลิก
                        </v-btn>
                        <v-btn
                          text
                          color="blue darken-2"
                          @click="$refs.menu2.save(conditons_transfer_successs_teach.cts_datetime)"
                        >
                          ตกลง
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>          
                </v-row>

                <v-row v-if="conditons_transfer_successs_teach.cts_report === 'nb'">
                          <!-- ข้อมูลสัญญาจ้าง -->
                  <v-col cols="12" class="mt-4">
                    <v-card outlined class="pa-4" color="grey lighten-5">
                      <h4 class="blue--text text--darken-2 mb-3">
                        <v-icon color="blue darken-2">mdi-file-document</v-icon>
                        ข้อมูลสัญญาจ้าง
                      </h4>
                      
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-menu
                            ref="contractStartMenu"
                            v-model="contractStartMenu"
                            :close-on-content-click="false"
                            :return-value.sync="contractData.contract_start_date"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="contractData.contract_start_date"
                                label="วันที่เริ่มสัญญา"
                                prepend-icon="mdi-calendar-start"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                outlined
                                required
                                :rules="[v => !!v || 'กรุณาเลือกวันที่เริ่มสัญญา']"
                                color="blue darken-2"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="contractData.contract_start_date"
                              no-title
                              scrollable
                              locale="th"
                              color="blue darken-2"
                            >
                              <v-spacer></v-spacer>
                              <v-btn text color="grey" @click="contractStartMenu = false">
                                ยกเลิก
                              </v-btn>
                              <v-btn
                                text
                                color="blue darken-2"
                                @click="$refs.contractStartMenu.save(contractData.contract_start_date)"
                              >
                                ตกลง
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>

                        <v-col cols="12" md="6">
                          <v-menu
                            ref="contractEndMenu"
                            v-model="contractEndMenu"
                            :close-on-content-click="false"
                            :return-value.sync="contractData.contract_end_date"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="contractData.contract_end_date"
                                label="วันที่สิ้นสุดสัญญา"
                                prepend-icon="mdi-calendar-end"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                outlined
                                required
                                :rules="[v => !!v || 'กรุณาเลือกวันที่สิ้นสุดสัญญา']"
                                color="blue darken-2"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="contractData.contract_end_date"
                              no-title
                              scrollable
                              locale="th"
                              color="blue darken-2"
                            >
                              <v-spacer></v-spacer>
                              <v-btn text color="grey" @click="contractEndMenu = false">
                                ยกเลิก
                              </v-btn>
                              <v-btn
                                text
                                color="blue darken-2"
                                @click="$refs.contractEndMenu.save(contractData.contract_end_date)"
                              >
                                ตกลง
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>

                        <v-col cols="12" md="6">
                          <v-text-field
                            v-model="contractData.contract_order"
                            label="เลขที่คำสั่ง"
                            prepend-icon="mdi-file-document-outline"
                            outlined
                            required
                            :rules="[v => !!v || 'กรุณากรอกเลขที่คำสั่ง']"
                            color="blue darken-2"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" md="6">
                          <v-text-field
                            v-model="contractData.created_by"
                            label="ผู้บันทึกข้อมูล"
                            prepend-icon="mdi-account"
                            outlined
                            color="blue darken-2"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12">
                          <v-textarea
                            v-model="contractData.contract_note"
                            label="หมายเหตุ"
                            prepend-icon="mdi-note-text"
                            outlined
                            rows="3"
                            color="blue darken-2"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>

                  <!-- ไฟล์แนบ -->
                  <v-col cols="12" md="6" class="mt-4">
                    <v-file-input
                      v-model="documentsLinkfiles"
                      accept=".pdf"
                      name="documentsLinkfiles"
                      color="blue darken-2"
                      counter
                      label="ไฟล์หนังสือราชการแจ้งการรายงานตัว.pdf"
                      placeholder="เลือกไฟล์หนังสือราชการ"
                      outlined
                      :show-size="1000"
                      :rules="fileRules"
                      prepend-icon="mdi-file-pdf-box"
                    >
                      <template v-slot:selection="{ index, text }">
                        <v-chip
                          v-if="index < 2"
                          color="blue darken-2"
                          text-color="white"
                          label
                          small
                        >
                          {{ text }}
                        </v-chip>
                        <span
                          v-else-if="index === 2"
                          class="text-overline grey--text text--darken-3 mx-2"
                        >
                          +{{ documentsLinkfiles.length - 2 }} File(s)
                        </span>
                      </template>
                    </v-file-input>
                  </v-col>

                  <v-col cols="12" md="6" class="mt-4">
                    <v-file-input
                      v-model="contractFile"
                      accept=".pdf"
                      name="contractFile"
                      color="blue darken-2"
                      counter
                      label="ไฟล์สัญญาจ้าง.pdf"
                      placeholder="เลือกไฟล์สัญญาจ้าง"
                      outlined
                      :show-size="1000"
                      :rules="contractFileRules"
                      prepend-icon="mdi-file-document"
                    >
                      <template v-slot:selection="{ index, text }">
                        <v-chip
                          v-if="index < 2"
                          color="blue darken-2"
                          text-color="white"
                          label
                          small
                        >
                          {{ text }}
                        </v-chip>
                      </template>
                    </v-file-input>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-card-actions class="pa-6">
              <v-spacer></v-spacer>
              <v-btn
                large
                outlined
                @click.stop="reportMoveTeachDialog = false"
                rounded
                color="grey"
              >
                <v-icon left>mdi-close</v-icon>
                ยกเลิก
              </v-btn>
              <v-btn
                large
                color="blue darken-2"
                @click="updateReportMoveTeachSubmit()"
                rounded
                class="white--text ml-4"
                :loading="saving"
              >
                <v-icon left>mdi-content-save</v-icon>
                บันทึกข้อมูล
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      saving: false,
      ApiKey: "HRvec2021",
      conditons_transfer_successs: [],
      search: "",
      pagination: {},
      singleSelect: false,
      reportMoveTeachDialog: false,
      selected: [],
      headers: [],
      selectedHeaders: [],
      headersMap: [
        { text: "ดำเนินการ", align: "left", value: "cts_report" },
        { text: "วันที่รายงานตัว", align: "left", value: "cts_datetime" },
        { text: "ฟอร์มสัญญาจ้างเพิ่มเติม", align: "left", value: "ex_contract" },
        { text: "File", align: "left", value: "cts_files" },
        { text: "ครั้งที่", align: "left", value: "ctstime_s" },
        { text: "ปีที่", align: "center", value: "ctsyear_s" },
        { text: "รหัสบัตรประชาชน", align: "center", value: "ctsid_card" },
        { text: "คำนำหน้าชื่อ", align: "center", value: "title_s" },
        { text: "ชื่อ", align: "center", value: "frist_name" },
        { text: "นามสกุล", align: "center", value: "last_name" },
        { text: "ตำแหน่ง", align: "center", value: "ctsname_position" },
        { text: "สังกัดใหม่", align: "center", value: "college_name_new" },
        { text: "เลขที่ตำแหน่งใหม่", align: "center", value: "ctsid_position" },
        { text: "รหัสสาขา", align: "center", value: "ctsid_branch" },
        { text: "เงื่อนไข", align: "center", value: "branch_name" },
        { text: "เลขที่ตำแหน่งเดิม", align: "left", value: "ctsid_postion_old" },
        { text: "สังกัดเดิม", align: "center", value: "college_name_old" }
      ],
      period_college: [],
      conditons_transfer_successs_teach: {},
      documentsLinkfiles: null,
      contractFile: null,
      contractData: {
        contract_start_date: '',
        contract_end_date: '',
        contract_order: '',
        contract_note: '',
        contract_file: '',
        created_by: ''
      },
      fileRules: [
        value => !value || value.size < 10485760 || "ไฟล์ไม่เกิน 10 MB / 10240 KB"
      ],
      contractFileRules: [
        value => !value || value.size < 10485760 || "ไฟล์สัญญาเพิ่มเติม ไม่เกิน 10 MB"
      ],
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu2: false,
      contractStartMenu: false,
      contractEndMenu: false
    };
  },

  async created() {
    this.headers = Object.values(this.headersMap);
    this.selectedHeaders = this.headers;
  },

  async mounted() {
    await this.periodQuery();
    if (this.period_college.period_college_enable != "1") {
      this.$router.push("/college");
    } else {
      await this.conditons_transfer_successQueryAll();
    }
  },

  methods: {
    // ฟังก์ชันตรวจสอบเวลา
    async timeCheck() {
      let dateNow = new Date();
      let dateStop = new Date(this.period_college.period_college_stop + " 16:30:00");
      let dateNows = dateNow.getTime();
      let dateStops = dateStop.getTime();
      
      if (dateNows > dateStops) {
        await this.periodTeacherUpdate();
      }
    },

    async periodTeacherUpdate() {
      this.period_college.ApiKey = this.ApiKey;
      this.period_college.period_college_enable = "0";
      this.period_college.period_college_enable_file = "0";
      await this.$http.post("period_college.update.php", this.period_college);
    },

    // ฟังก์ชันยกเลิกการสอน
    async cancelTeach(id_cts) {
      let result = await this.$http.post("conditons_transfer_success.php", {
        ApiKey: this.ApiKey,
        id_cts: id_cts
      });
      this.conditons_transfer_successs_teach = result.data;
      let charText = this.conditons_transfer_successs_teach.full_name;
      
      Swal.fire({
        title: "ขอยกเลิกรายการ เนื่องจากรายงานผิดพลาด",
        text: charText,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#1976d2",
        cancelButtonColor: "#757575",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก"
      }).then(async result => {
        if (result.isConfirmed) {
          this.conditons_transfer_successs_teach.ApiKey = this.ApiKey;        
          this.conditons_transfer_successs_teach.cts_college_cc = "CC";

          let resultup = await this.$http.post(
            "conditons_transfer_success.update.php",
            this.conditons_transfer_successs_teach
          );
          
          if (resultup.data.status == true) {
            Swal.fire({
              title: "ดำเนินการข้อมูลเรียบร้อย",
              icon: "success",
              showConfirmButton: false,
              timer: 1500
            });
            await this.conditons_transfer_successQueryAll();
          } else {
            Swal.fire({
              icon: "warning",
              title: "ผิดพลาด",
              showConfirmButton: false,
              timer: 1500
            });
          }
        }
      });
    },

    // ฟังก์ชันบันทึกข้อมูลการรายงานตัวพร้อมสัญญาจ้าง
    async updateReportMoveTeachSubmit() {
      if (this.$refs.updatemvtform.validate()) {
        this.saving = true;
        
        try {
          let reportFileUploaded = false;
          let contractFileUploaded = false;
          
          // อัปโหลดไฟล์หนังสือราชการ
          if (this.documentsLinkfiles) {
            let formData = new FormData();
            let filename = this.conditons_transfer_successs_teach.id_cts + 
                          this.conditons_transfer_successs_teach.ctsid_ref + 
                          "reportmvteach.pdf";
            
            formData.append("ApiKey", this.ApiKey);
            formData.append("file", this.documentsLinkfiles);
            formData.append("filename", "../HRvecfiles/" + filename);

            let result = await this.$http.post("uploadfile.php", formData, {
              headers: { "Content-Type": "multipart/form-data" }
            });
            
            if (result.data.status == true) {
              this.conditons_transfer_successs_teach.cts_files = filename;
              reportFileUploaded = true;
            }
          }

          // อัปโหลดไฟล์สัญญาจ้าง
          if (this.contractFile) {
            let formData = new FormData();
            let contractFilename = this.conditons_transfer_successs_teach.ctsid_card + 
                                  "_contract_" + 
                                  new Date().getTime() + ".pdf";
            
            formData.append("ApiKey", this.ApiKey);
            formData.append("file", this.contractFile);
            formData.append("filename", "../HRvecfiles/" + contractFilename);

            let result = await this.$http.post("uploadfile.php", formData, {
              headers: { "Content-Type": "multipart/form-data" }
            });
            
            if (result.data.status == true) {
              this.contractData.contract_file = contractFilename;
              contractFileUploaded = true;
            }
          }

          // บันทึกข้อมูลสัญญาจ้าง
          if (this.conditons_transfer_successs_teach.cts_report === 'nb') {
            this.contractData.id_card = this.conditons_transfer_successs_teach.ctsid_card;
            this.contractData.ApiKey = this.ApiKey;
            
            let contractResult = await this.$http.post(
              "gov_em_contract_history.insert.php", 
              this.contractData
            );
            
            if (!contractResult.data.status) {
              throw new Error("ไม่สามารถบันทึกข้อมูลสัญญาจ้างได้");
            }
          }

          // อัปเดตข้อมูลการรายงานตัว
          this.conditons_transfer_successs_teach.ApiKey = this.ApiKey;
          let updateResult = await this.$http.post(
            "conditons_transfer_success.update.php",
            this.conditons_transfer_successs_teach
          );

          if (updateResult.data.status || reportFileUploaded || contractFileUploaded) {
            Swal.fire({
              icon: "success",
              title: "ดำเนินการบันทึกข้อมูลเรียบร้อย",
              text: "ข้อมูลการรายงานตัวและสัญญาจ้างถูกบันทึกแล้ว",
              showConfirmButton: false,
              timer: 2000
            });
            
            await this.conditons_transfer_successQueryAll();
            this.reportMoveTeachDialog = false;
            this.resetForm();
          } else {
            throw new Error("ไม่สามารถบันทึกข้อมูลได้");
          }

        } catch (error) {
          console.error('Error saving data:', error);
          Swal.fire({
            icon: "error",
            title: "เกิดข้อผิดพลาด",
            text: error.message || "ไม่สามารถบันทึกข้อมูลได้ กรุณาลองใหม่อีกครั้ง",
            showConfirmButton: true
          });
        } finally {
          this.saving = false;
        }
      }
    },

    // รีเซ็ตฟอร์ม
    resetForm() {
      this.conditons_transfer_successs_teach = {};
      this.documentsLinkfiles = null;
      this.contractFile = null;
      this.contractData = {
        contract_start_date: '',
        contract_end_date: '',
        contract_order: '',
        contract_note: '',
        contract_file: '',
        created_by: ''
      };
      this.$refs.updatemvtform.reset();
    },

    // เปิดหน้าต่างรับรายงานตัว
    async receiptTeach(id_cts) {
      let result = await this.$http.post("conditons_transfer_success.php", {
        ApiKey: this.ApiKey,
        id_cts: id_cts
      });
      
      this.conditons_transfer_successs_teach = result.data;
      
      // ตั้งค่าเริ่มต้นสำหรับข้อมูลสัญญา
      let userSession = JSON.parse(sessionStorage.getItem("user")) || {};
      this.contractData = {
        contract_start_date: this.date,
        contract_end_date: '',
        contract_order: '',
        contract_note: '',
        contract_file: '',
        created_by: userSession.full_name || ''
      };
      
      this.reportMoveTeachDialog = true;
    },

    // ดึงข้อมูลช่วงเวลา
    async periodQuery() {
      let result_period = await this.$http.post("period_college.php", {
        ApiKey: this.ApiKey,
        period_college_id: '80103'
      });
      this.period_college = result_period.data;
    },

    // ดึงข้อมูลการย้ายทั้งหมด
    async conditons_transfer_successQueryAll() {
      let userSession = JSON.parse(sessionStorage.getItem("user")) || {};
      this.loading = true;
      
      try {
        let result = await this.$http.post("conditons_transfer_success.php", {
          ApiKey: this.ApiKey,
          ctstime_s: this.period_college.period_college_times,
          ctsyear_s: this.period_college.period_college_year,
          ctscollege_code: userSession.user_name
        });
        
        this.conditons_transfer_successs = result.data;
        
        let sum = this.conditons_transfer_successs.length;
        let reportedCount = this.conditons_transfer_successs.filter(item => item.cts_report === 'nb').length;
        let notReportedCount = this.conditons_transfer_successs.filter(item => item.cts_report === 'dnb').length;
        let pendingCount = sum - reportedCount - notReportedCount;
        
        let charttext = `จำนวน พนักงานราชการ ย้ายเข้า: ${sum} คน\n` +
                       `รายงานตัวแล้ว: ${reportedCount} คน\n` +
                       `ไม่มารายงานตัว: ${notReportedCount} คน\n` +
                       `รอดำเนินการ: ${pendingCount} คน`;
        
        Swal.fire({
          title: "สถานะการย้าย",
          text: charttext,
          icon: "info",
          confirmButtonColor: "#1976d2",
          showConfirmButton: true
        });
        
      } catch (error) {
        console.error('Error fetching data:', error);
        Swal.fire({
          icon: "error",
          title: "ไม่สามารถโหลดข้อมูลได้",
          text: "กรุณาลองใหม่อีกครั้ง",
          showConfirmButton: true
        });
      } finally {
        this.loading = false;
      }
    },

    // กำหนดสีแถว
    getColor(calories) {
      if (calories > 0) return "green";
      else return "";
    },

    // กำหนด class ของแถว
    row_classes(item) {
      if (item.ctsstatus_select == "transfer") {
        return "grey lighten-4";
      }
      if (item.cts_college_cc === "CC") {
        return "orange lighten-5";
      }
      if (item.cts_report === "nb") {
        return "blue lighten-5";
      }
      return "";
    }
  },

  computed: {
    // คำนวณจำนวนหน้า
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },

    // สีของการ์ด
    color() {
      return "blue darken-2";
    },

    // วันที่ปัจจุบัน
    date_today_cal() {
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0");
      let yyyy = today.getFullYear();
      today = yyyy + "-" + mm + "-" + dd;
      return today;
    },

    // หัวข้อที่จะแสดง
    showHeaders() {
      return this.headers.filter(s => this.selectedHeaders.includes(s));
    }
  }
};
</script>

<style scoped>
/* สไตล์โทนสีขาว */
.white-theme {
  background-color: #ffffff;
}

.v-data-table {
  background-color: white !important;
}

.v-card {
  background-color: white !important;
}

.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: #f5f5f5 !important;
}

.orange {
  background-color: #fff3e0;
}

.blue-light {
  background-color: #e3f2fd;
}

/* ปรับปรุงการแสดงผลของ Chips */
.v-chip {
  font-weight: 500;
  letter-spacing: 0.5px;
}

/* สไตล์สำหรับฟอร์ม */
.v-text-field--outlined fieldset {
  border-color: #e0e0e0;
}

.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) .v-label {
  color: #616161;
}

/* สไตล์สำหรับปุ่ม */
.v-btn {
  text-transform: none;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.v-btn--rounded {
  border-radius: 28px;
}

/* Animation สำหรับ Dialog */
.v-dialog {
  border-radius: 16px;
}

.v-card {
  border-radius: 12px;
}

/* สไตล์สำหรับ Date Picker */
.v-picker {
  border-radius: 12px;
}

/* สไตล์สำหรับ File Input */
.v-file-input .v-file-input__text {
  color: #424242;
}

/* เพิ่มเงาให้กับ Card */
.v-card--material {
  box-shadow: 0 8px 26px -4px rgba(0, 0, 0, 0.15), 0 8px 9px -5px rgba(0, 0, 0, 0.06) !important;
}

/* สไตล์สำหรับส่วนหัวของตาราง */
.v-data-table-header {
  background-color: #fafafa;
}

.v-data-table-header th {
  color: #424242 !important;
  font-weight: 600;
}

/* สไตล์สำหรับการแจ้งเตือน */
.v-alert {
  border-radius: 8px;
  font-weight: 500;
}

/* Responsive Design */
@media (max-width: 960px) {
  .v-dialog {
    margin: 16px;
  }
  
  .v-card {
    margin: 0;
  }
}

/* เพิ่มความนุ่มนวลให้กับ Transition */
.scale-transition-enter-active,
.scale-transition-leave-active {
  transition: transform 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

/* สีสำหรับสถานะต่างๆ */
.status-reported {
  background-color: #e8f5e8 !important;
  border-left: 4px solid #4caf50;
}

.status-not-reported {
  background-color: #fff3e0 !important;
  border-left: 4px solid #ff9800;
}

.status-cancelled {
  background-color: #ffebee !important;
  border-left: 4px solid #f44336;
}

.status-pending {
  background-color: #f3e5f5 !important;
  border-left: 4px solid #9c27b0;
}
</style>